export const FILTER_BY_WEBFORM_OPTIONS = ['Business Connect', 'Wireline/Security',
    'Wireless', 'MyOD (order tracking tool)', 'Phone Number Check', 'Business Connect Contact Centre',
    'Referral Tool'];

export const FILTER_BY_DEFECT_CATEGORY_OPTIONS = ['User Info', 'Offers & Pricing', 'Behavioural issue'];
export const FILTER_BY_STATUS_OPTIONS = ['New', 'In Progress', 'Resolved'];
export const FILTERS_INIT_STATE = {
    defectWebform: '',
    defectCategory: '',
    status: ''
};
export const DEFECTS_PER_PAGE = 50;
